import { CatIconExternalLinkBox } from 'blocks-nextjs/blocks-react/components/Icons/ExternalLinkBox';
import styles from './FooterLegalLinks.module.scss';
import cx from 'classnames';

export interface LegalLink {
  name: string;
  url: string;
  display: boolean;
  target?: string;
  label: string;
  className?: string;
}

interface FooterLegalLinksProps {
  legalLinks: LegalLink[];
  isFooterDesignUpdate: boolean;
  isFooterLinksSortActive: boolean;
}

export const FooterLegalLinks = ({
  legalLinks,
  isFooterDesignUpdate,
  isFooterLinksSortActive
}: FooterLegalLinksProps) => {
  const ShouldShowIcons = isFooterDesignUpdate;
  return (
    <div
      className={
        isFooterLinksSortActive
          ? styles['footer__legal__links__sort-box']
          : styles['footer__legal__links-box']
      }
    >
      {legalLinks
        ?.filter((legalLink) => legalLink.display)
        .map((legalLink) => (
          <a
            href={legalLink.url}
            target={legalLink.target}
            key={legalLink.name}
            className={cx(
              styles['footer__legal__links-link'],
              legalLink.className,
              'exclude-global',
              {
                [styles['with-icon']]: ShouldShowIcons
              }
            )}
            aria-label={legalLink.label}
            suppressHydrationWarning
            // Suppress hydration warning for className "ot-sdk-show-settings".
            // This class name is conditionally applied based on the presence of cookies, which can result in inconsistent rendering
            // between Server Side Rendering (SSR) and Client Side Rendering (CSR) due to differences in cookie availability.
          >
            <div className={cx(styles['footer__legal__links-link-container'])}>
              {ShouldShowIcons && (
                <CatIconExternalLinkBox
                  className={styles['footer__legal__links-icon']}
                />
              )}
              {legalLink.label}
            </div>
          </a>
        ))}
    </div>
  );
};
